export interface AppConfig {
  pageTitle: string;
  pageDescription: string;
  companyName: string;

  supportsChatInput: boolean;
  supportsVideoInput: boolean;
  supportsScreenShare: boolean;
  isPreConnectBufferEnabled: boolean;

  logo: string;
  startButtonText: string;
  accent?: string;
  logoDark?: string;
  accentDark?: string;

  // for LiveKit Cloud Sandbox
  sandboxId?: string;
  agentName?: string;
}

export const APP_CONFIG_DEFAULTS: AppConfig = {
  companyName: 'Decoa',
  pageTitle: 'Decoa Interview Agent',
  pageDescription: 'A polished interview assistant for client-grade research sessions.',

  supportsChatInput: true,
  supportsVideoInput: true,
  supportsScreenShare: true,
  isPreConnectBufferEnabled: true,

  logo: '/Decoa_logo_w.svg',
  accent: '#0f766e',
  logoDark: '/Decoa_logo_w.svg',
  accentDark: '#22c6aa',
  startButtonText: 'Start interview',

  // for LiveKit Cloud Sandbox
  sandboxId: undefined,
  agentName: undefined,
};
